import { useCallback, useMemo } from 'react';
import { postMessageToParent } from '../post-message/postMessageToParent';
import { SCREEN_CAPTURE_REQUEST } from '../constants/PostMessageTypes';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import VizExTooltip from 'visitor-ui-component-library/tooltip/VizExTooltip';
import SVGImage from 'visitor-ui-component-library-icons/icons/SVGImage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export function ScreenCaptureButton({
  mobile,
  disabled
}) {
  const supportsScreenCapture = useMemo(() => {
    return navigator.mediaDevices && typeof navigator.mediaDevices.getDisplayMedia === 'function' && !mobile;
  }, [mobile]);
  const captureScreenshot = useCallback(() => {
    postMessageToParent(SCREEN_CAPTURE_REQUEST);
  }, []);
  if (!supportsScreenCapture) {
    return null;
  }
  return /*#__PURE__*/_jsx(VizExTooltip, {
    content: I18n.text('conversations-visitor-experience-components.screenCapture'),
    placement: "top right",
    children: /*#__PURE__*/_jsx(VizExIconButton, {
      disabled: disabled,
      onClick: captureScreenshot,
      use: "default",
      shape: "circle",
      "aria-label": I18n.text('conversations-visitor-experience-components.screenCapture'),
      children: /*#__PURE__*/_jsx(VizExIcon, {
        icon: /*#__PURE__*/_jsx(SVGImage, {}),
        size: "18px"
      })
    })
  });
}
ScreenCaptureButton.displayName = 'ScreenCaptureButton';